import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace } from '@/hooks/api/models';

/**
 * 0270. チーム受注フェーズ名編集
 * [PUT] /workspaces/:identifier/teams/:team_id/team_sales_order_phases/:team_sales_order_phase_id
 */
type Props = {
  identifier: string;
  team_id: number;
  phase_id: number;
  label: string;
};
export const updateTeamSalesOrderPhases = (props: Props): Promise<Workspace> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/team_sales_order_phases/${props.phase_id}`, props);
};

export const useUpdateTeamSalesOrderPhases = () => {
  return useMutation({
    mutationFn: updateTeamSalesOrderPhases,
  });
};
